import { render, staticRenderFns } from "./ColumnOrderStatus.vue?vue&type=template&id=11879b91&scoped=true"
import script from "./ColumnOrderStatus.vue?vue&type=script&lang=js"
export * from "./ColumnOrderStatus.vue?vue&type=script&lang=js"
import style0 from "./ColumnOrderStatus.vue?vue&type=style&index=0&id=11879b91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11879b91",
  null
  
)

export default component.exports